<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12 col-xxl-12">
          <h2 class="text-center pb-10">Formulaire de création d'un utilisateur</h2>
          <FormUser 
            v-model="formData" 
            @submit="submit"
            mode="add"
          ></FormUser>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import FormUser from "@/components/admin/user/forms/formUser.vue";

import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "addUser",
  components: {
    FormUser,
  },
  data: () => ({
    formData: {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      comment: "",
      roles: null,
      userRight: null,
      client: null,
    },
  }),
  props:{
    userRight: Object,
    client: Object,
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients"},
      { title: "Gestion des comptes utilisateurs" },
      { title: "Créer un utilisateur" },
    ]);
  },
  methods: {
      submit: async function() {
          
      try {
        await Api.post("users", {
          firstname: this.formData.firstname,
          lastname: this.formData.lastname,
          email: this.formData.email,
          password: this.formData.password,
          comment: this.formData.comment,
          roles: [this.formData.roles],
          userRight:  this.formData.userRight ? this.formData.userRight['@id'] : null,
          client: this.formData.client ? this.formData.client['@id'] : null,
        });
        
         Swal.fire({
          title: "",
          text: "L'utilisateur a été crée.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
        this.$router.push({ name: 'gestionClients', query: {
                  selected: 'tab-users',
                },})
      } catch (error) {
        //Dans le cas où la requête a échoué.
        Swal.fire({
          title: "",
          text: "Une erreur est survenue lors de la création de l'utilisateur",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        return;
      }

    },
  }
};
</script>
